import Vue from "vue";
import Vuetify from "vuetify";
import fa from "vuetify/es5/locale/fa";
import en from "vuetify/es5/locale/en";
import "@mdi/font/css/materialdesignicons.css";
import "../../node_modules/vuetify/dist/vuetify.min.css";

// Vue.use(currency);

Vue.use(Vuetify, {
    rtl: false,
    iconfont: "mdi",
    theme: {
        grey1: "#393A3D",
        grey2: "#6B6C72",
        grey3: "#8D9096",
        grey4: "#BABEC5",
        grey5: "#D4D7DC",
        grey6: "#E3E5E8",
        grey7: "#ECEEF1",
        grey8: "#F4F5F8",
        ptsColor: "#1b1464",
        darkBlue: "#193048",
        // secondary: "#00ACC1",
        primary: "#13aa52",
        secondary: "#42494f",
        activeColor: "#2196F3",
        creative_team_green: "43a047",
        accent: "#13aa52",
        darkRed: "#d90404",
        bp_dark: "#232342",
        bp_green: "#0bb351",
        // bill_color:"#42494f",
        bill_text_color:"#42494f"


        // primary: '#42494f', // grey
        // darkPrimary: '#116149', // grey dark
        // green
    },
    customProperties: true,
    lang: { locales: { en, fa }, current: "en" }
});
